<template>
  <mapObjNeu :ueberschrift="'Hilfe im Wald'" :mapObj="'hiw'"/>
</template>

<script>
import mapObjNeu from "@/components/mapObjNeu.vue";

export default {
  name: "HilfeImWald",
  components: {
    mapObjNeu
  },
  data() {

  },
  methods: {
    
  },
  async created() {
    
  },
  onMounted() {

  },
  setup() {
    
  }
}
</script>